module.exports = __webpack_public_path__ + "static/lorencova-e4f983cc5ee3a673aa6d2b6d2f113a2a.jpg";